export default __webpack_public_path__ + "static/media/signature.f1802793.png";